import { iconPrefix } from "./meta";

/* NOTE: Icons cannot have the same unicode
 While doing the filled icons the same unicode was assigned to both bookmark and bookmark-filled
 this works ok with SVG because each one has its own path and <svg>
 on fonts only the since they both use the same unicode, only the last one will be assigned

 The ellipsis and overflow are mislabled.  Ellipsis should be \\22ef which is the unicode for a "midline horizontal ellipsis"
 and overflow should be \\22ee, which is the unicode for a "vertical ellipsis".  As these changes would be breaking changes,
 they will be applied in v3.
 */

// Existing unicodes
const defaultIconsUnicode = {
    accessibility: "\\267f",
    "add-sqr": "\\229e",
    airplane: "\\1f6ea",
    "alarm-bell": "\\1f56d",
    "alarm-clock": "\\1f551",
    "alert-check-cir": "\\1f5f8",
    "alert-check-sqr": "\\1f5f9",
    "alert-error": "\\26d4",
    "alert-info-cir": "\\1f6c8",
    "alert-notice": "\\26a0",
    "app-window": "\\1f5d4",
    "arrow-cir-down": "\\2b73",
    "arrow-cir-left": "\\2b70",
    "arrow-cir-right": "\\2b72",
    "arrow-cir-up": "\\2b71",
    "arrow-down": "\\2193",
    "arrow-export": "\\2197",
    "arrow-left": "\\2190",
    "arrow-right": "\\2192",
    "arrow-tri-down": "\\25bd",
    "arrow-tri-left": "\\25c1",
    "arrow-tri-right": "\\25b7",
    "arrow-tri-solid-right": "\\23f5",
    "arrow-tri-up": "\\20e4",
    "arrow-up": "\\2191",
    assistance: "\\1f481",
    "audio-speaker": "\\1f508",
    "audio-speaker-mute": "\\1f507",
    "audio-speaker-on": "\\1f50a",
    "award-certificate": "\\1f397",
    "award-trophy": "\\1f3c6",
    "battery-charge": "\\1f50b",
    bolt: "\\1f5f2",
    bookmark: "\\1f516",
    "book-open": "\\1f4d6",
    brightness: "\\1f505",
    calculator: "\\1f5a9",
    calendar: "\\1f4c5",
    camera: "\\1f4f7",
    cancelled: "\\20e0",
    "capture-image": "\\2b",
    "card-credit": "\\1f4b4",
    "card-info": "\\1f4b3",
    "carry-case": "\\1f4bc",
    cart: "\\1f6d2",
    "chain-link": "\\1f587",
    "charge-back": "\\1f4b0",
    "chart-bars-axis": "\\1f4ca",
    "chart-bars-box": "\\1f4c9",
    "chart-insights": "\\1f4c8",
    "chat-bot": "\\1f916",
    "chat-dots": "\\1f4ac",
    check: "\\2713",
    "chevron-cir-down": "\\2b8b",
    "chevron-cir-left": "\\2b88",
    "chevron-cir-right": "\\2b8a",
    "chevron-cir-up": "\\2b89",
    "chevron-down": "\\fe40",
    "chevron-left": "\\2329",
    "chevron-right": "\\232a",
    "chevron-up": "\\fe3f",
    "chip-set": "\\25a6",
    clipboard: "\\1f4cb",
    clock: "\\1f552",
    "clock-arrow-left": "\\1f553",
    "clock-arrow-right": "\\1f555",
    clone: "\\1f5d7",
    "close-x": "\\1f5d9",
    "close-back": "\\2326",
    "close-cir": "\\1f5f5",
    "close-sqr": "\\1f5f7",
    cloud: "\\2601",
    "cloud-check": "\\1f329",
    "collapse-down-sqr": "\\23ec",
    "collapse-up-sqr": "\\23eb",
    comment: "\\1f5e8",
    compare: "\\2966",
    conversation: "\\1f5ea",
    "conversation-cir": "\\1f5eb",
    copy: "\\1f5c7",
    "copy-alt": "\\1f5cd",
    cube: "\\1f4e6",
    currency: "\\24",
    cursor: "\\261d",
    "d-display": "\\1f5b5",
    dashboard: "\\1f5e0",
    "data-center": "\\1f3e2",
    "data-compute": "\\1f5ad",
    datastore: "\\1f5ac",
    debug: "\\1f41e",
    "device-data-center": "\\1f5aa",
    "device-laptop": "\\1f5b4",
    "device-mobile": "\\1f581",
    "device-modular": "\\1f4bb",
    "device-monitor": "\\239a",
    "device-server": "\\1f5b6",
    "device-server-tower": "\\1f5a5",
    diagnostic: "\\1f5e1",
    "dimensions-weight": "\\1f4cf",
    "disc-software": "\\1f5b8",
    "doc-add": "\\1f5b9",
    "doc-arrow-left": "\\1f5ba",
    "doc-arrow-right": "\\1f5cb",
    "doc-lines": "\\1f5c8",
    "doc-reports": "\\1f5c9",
    document: "\\1f5cf",
    "download-alt": "\\2913",
    ear: "\\1f442",
    "energy-efficient": "\\1f333",
    "escalate-tri": "\\29cb",
    "exit-door": "\\21da",
    "eye-view-on": "\\1f441",
    fan: "\\274b",
    filter: "\\26db",
    fingerprint: "\\1f446",
    flag: "\\26ff",
    flame: "\\1f525",
    "flash-drive": "\\1f4bd",
    folder: "\\1f5c0",
    "folder-add": "\\1f5c2",
    "folder-arrow-right": "\\1f5bf",
    "full-screen": "\\1f5d6",
    gear: "\\2699",
    "globe-simple": "\\1f310",
    handle: "\\22ee",
    "hand-touch": "\\1f5a2",
    "hard-drive": "\\1f5ab",
    heart: "\\2661",
    "heart-filled": "\\2665",
    "help-cir": "\\2bd1",
    hinge: "\\1f5b3",
    home: "\\1f3e1",
    import: "\\21a7",
    "import-alt": "\\21a5",
    inbox: "\\1f4e5",
    "ink-toner": "\\1f5a8",
    key: "\\1f511",
    keyboard: "\\2328",
    "keyboard-mouse": "\\1f5a6",
    "laptop-generic": "\\1f5b7",
    lightbulb: "\\1f4a1",
    location: "\\1f4cd",
    "lock-closed": "\\1f512",
    "lock-open": "\\1f513",
    "log-in": "\\2348",
    mail: "\\1f582",
    "mail-open": "\\1f586",
    "menu-closed": "\\2630",
    "microphone-off": "\\1f3a4",
    "minus-minimize": "\\2212",
    "missing-image": "\\26f6",
    mouse: "\\1f5b0",
    "mouse-cord": "\\1f5af",
    "movie-clapper": "\\1f3ac",
    "movie-clapper-play": "\\1f3a6",
    "music-note": "\\1f39d",
    "network-vert": "\\1f5a7",
    office: "\\1f3e3",
    overflow: "\\22ef",
    "paint-brush": "\\1f58c",
    "paint-palette": "\\1f3a8",
    "paper-clip": "\\1f4ce",
    partners: "\\270b",
    pause: "\\23f8",
    pencil: "\\1f589",
    "pencil-check": "\\1f58a",
    "pencil-mark": "\\1f58e",
    performance: "\\23f2",
    phone: "\\1f57e",
    pin: "\\1f4cc",
    "play-cir": "\\23ef",
    "popout-window": "\\2398",
    "pop-up-arrow": "\\21f1",
    "power-supply": "\\1f50c",
    printer: "\\1f4e0",
    projector: "\\1f4fe",
    recycle: "\\2672",
    "recycle-bin": "\\267b",
    redo: "\\2b8e",
    "redo-move": "\\27f3",
    "refresh-spin": "\\1f5d8",
    "remove-cir": "\\229d",
    "remove-sqr": "\\229f",
    reset: "\\27f2",
    restore: "\\2b79",
    save: "\\2357",
    "save-disk": "\\1f4be",
    scale: "\\2912",
    search: "\\1f50d",
    "search-arrow-left": "\\1f50e",
    "search-back": "\\23ee",
    "search-forward": "\\23ed",
    share: "\\21b7",
    shield: "\\26c9",
    "shield-check": "\\26ca",
    "slider-vert": "\\1f39a",
    snapshot: "\\2bd0",
    snowflake: "\\2744",
    "sort-horiz": "\\2b82",
    "sort-vert": "\\296e",
    star: "\\2729",
    "star-filled": "\\2605",
    stop: "\\23f9",
    "sync-horiz": "\\2b94",
    tag: "\\1f3f7",
    "thumb-down": "\\1f44e",
    "thumb-up": "\\1f44d",
    trash: "\\1f5d1",
    tv: "\\1f4fa",
    undo: "\\2b8c",
    "undo-move": "\\2b6e",
    upload: "\\2b6b",
    user: "\\1f469",
    "user-group": "\\1f46a",
    "user-groups": "\\1f46b",
    "view-column": "\\25a5",
    "view-grid": "\\25a4",
    "view-grid-alt": "\\25a9",
    warranty: "\\1f5f0",
    "weight-bell": "\\1f514",
    wifi: "\\1f4e1",
    "wrench-single": "\\1f527",
    "wrench-tools": "\\1f6e0",
};

// This object is ordered based on custom unicode (E000—F8FF) https://en.wikipedia.org/wiki/Private_Use_Areas
const customIconsUnicode = {
    "wifi-none": "\\e900",
    "globe-location": "\\e901",
    "brand-skype": "\\e902",
    "gift-card": "\\e903",
    metadata: "\\e904",
    objects: "\\e905",
    "play-sqr": "\\e906",
    "plus-add": "\\e907",
    "sort-az": "\\e908",
    ellipsis: "\\e909",
    arrange: "\\e910",
    volume: "\\e911",
    "arrow-tri-solid-stacked": "\\e912",
    "popout-double-condense-vertical": "\\e913",
    "popout-double-condense": "\\e914",
    barbell: "\\e915",
    expand: "\\e916",
    "currency-coins-pounds": "\\e917",
    "currency-coins-rupees": "\\e918",
    "currency-coins-yen": "\\e919",
    "audio-card": "\\e920",
    "popout-double-vertical": "\\e921",
    "audio-speaker-levels": "\\e922",
    "device-desktop": "\\e923",
    "audio-speaker-off": "\\e924",
    "calendar-add": "\\e925",
    "calendar-check": "\\e926",
    "calendar-remove": "\\e927",
    "heart-half-filled": "\\e928",
    "battery-empty": "\\e929",
    "star-half-filled": "\\e930",
    "thumb-down-filled": "\\e931",
    "thumb-up-filled": "\\e932",
    "brand-alienware": "\\e933",
    "brand-dell": "\\e934",
    "brand-dellemc": "\\e935",
    "brand-delltechnologies": "\\e937",
    "brand-delltechnologiesvert": "\\e938",
    "bookmark-filled": "\\e939",
    // #### (e940) next icon marker ####
    "card-swipe-left": "\\e941",
    "card-swipe-right": "\\e942",
    "charge-back-folder": "\\e947",
    "charge-back-report": "\\e948",
    "clipboard-check": "\\e959",
    "cloud-document": "\\e968",
    "cloud-iq": "\\e969",
    "column-add": "\\e971",
    "comment-add": "\\e973",
    "comment-check": "\\e974",
    deploy: "\\e984",
    "device-laptop-detachable": "\\e987",
    "device-lock-screen": "\\e988",
    "device-storage-array": "\\e990",
    "device-switch-blade": "\\e991",
    "device-switch-blade-2U": "\\e992",
    "device-tablet-horiz": "\\e993",
    "device-tablet-vert": "\\e994",
    "device-thin-client": "\\e995",
    "disc-arrow-down": "\\e998",
    "disc-arrow-up": "\\e999",
    "brand-dell-gaming": "\\e90a",
    "tag-deal": "\\e90b",
    "alert-info-sqr": "\\e90c",
    "user-directory": "\\e90d",
    "brand-windows": "\\e90e",
    "app-window-search": "\\e90f",
    "currency-coins-indian-rupees": "\\e91a",
    "currency-coins-generic": "\\e91b",
    "currency-coins-euros": "\\e91c",
    "add-cir": "\\e91d",
    "game-controller": "\\e91e",
    "gaming-desktop": "\\e91f",
    "battery-horiz-empty": "\\e92a",
    "battery-horiz-full": "\\e92b",
    "battery-horiz-half": "\\e92c",
    "battery-vert-full": "\\e92d",
    "battery-vert-half": "\\e92e",
    bluetooth: "\\e92f",
    "calendar-search": "\\e93c",
    "check-property": "\\e94e",
    "clipboard-lines": "\\e95a",
    "clipboard-notes": "\\e95b",
    "clipboard-remove": "\\e95c",
    "clipboard-search": "\\e95d",
    "cloud-restore": "\\e96a",
    "cloud-upload": "\\e96b",
    "cloud-wireless": "\\e96c",
    "collapse-down": "\\e96d",
    "collapse-up": "\\e96f",
    "currency-coins": "\\e97c",
    "cursor-clock": "\\e97e",
    "device-nodes": "\\e98c",
    "device-screen-size": "\\e98d",
    "disc-check": "\\e99a",
    "disc-insert": "\\e99b",
    "disc-recovery": "\\e99c",
    "disc-secure": "\\e99d",
    "disc-system": "\\e99f",
    "doc-check": "\\e9a3",
    "doc-cube": "\\e9a4",
    "doc-manual": "\\e9a6",
    "docs-copy-alt": "\\e9a8",
    "doc-search": "\\e9a9",
    "doc-secure": "\\e9aa",
    "doc-settings": "\\e9ab",
    "doc-support": "\\e9ac",
    download: "\\e9ae",
    "eye-view-off": "\\e9b6",
    "filter-add": "\\e9ba",
    "filter-clear": "\\e9bb",
    "filter-move": "\\e9bc",
    "filter-remove": "\\e9bd",
    "folder-arrow-up": "\\e9c5",
    "folder-media": "\\e9c6",
    "gear-arrow": "\\e9c9",
    "gear-wrench": "\\e9ca",
    "graphics-card": "\\e9cd",
    "hand-touch-screen": "\\e9d0",
    "hd-generic": "\\e9d2",
    headphones: "\\e9d3",
    headset: "\\e9d4",
    heat: "\\e9d5",
    "help-sqr": "\\e9d7",
    "host-server": "\\e9d9",
    "host-server-hex": "\\e9da",
    "host-server-rack": "\\e9db",
    "inbox-arrow-down": "\\e9df",
    infrastructure: "\\e9e0",
    keypad: "\\e9e5",
    lcd: "\\e9e7",
    "location-play": "\\e9ea",
    "log-out": "\\e9ee",
    leaf: "\\e9eh",
    "manage-info": "\\e9f1",
    "management-software": "\\e9f2",
    memory: "\\e9f3",
    "memory-card-reader": "\\e9f4",
    "memory-sd-card": "\\e9f5",
    microchip: "\\e9f8",
    "microphone-on": "\\e9fa",
    migrate: "\\e9fb",
    minimize: "\\e9fc",
    "2-in-1": "\\eaa3",
    "pre-seed": "\\eaa4",
    receipt: "\\eaa5",
    "brand-xps": "\\eaa6",
    "data-protection": "\\eaa7",
    "hyper-converged-infrastructure": "\\eaa8",
    unpin: "\\eaa9",
    "network-connected": "\\ea04",
    "network-horiz": "\\ea05",
    "network-share": "\\ea06",
    "network-vert-disable": "\\ea08",
    partnership: "\\ea09",
    // Deepcode ignore NoHardcodedPasswords: this is a false positive, the stored info reffers to an icon, not a password, the name password identifies that it is a password icon
    password: "\\ea12",
    "pause-sqr": "\\ea14",
    "pencil-remove": "\\ea18",
    "popout-double": "\\ea21",
    "popout-share": "\\ea22",
    "popout-window-arrow": "\\ea24",
    "pop-up-arrow-corner": "\\ea26",
    "port-double": "\\ea27",
    "power-off": "\\ea28",
    "power-on": "\\ea29",
    protractor: "\\ea31",
    pulse: "\\ea32",
    puzzle: "\\ea33",
    qos: "\\ea34",
    rack: "\\ea35",
    rss: "\\ea40",
    "search-arrow-right": "\\ea46",
    "server-rack-arrow-right": "\\ea49",
    shipping: "\\ea50",
    "skip-forward": "\\ea51",
    "skip-to-end": "\\ea52",
    "skip-to-front": "\\ea53",
    "slider-horiz": "\\ea54",
    "smart-select": "\\ea56",
    "social-networking": "\\ea59",
    "start-up": "\\ea61",
    suspend: "\\ea63",
    "sync-vert": "\\ea65",
    "task-check": "\\ea68",
    "task-check-progress": "\\ea69",
    usb: "\\ea73",
    "user-about": "\\ea75",
    "user-add": "\\ea76",
    "user-check": "\\ea77",
    "user-cir": "\\ea78",
    "user-cir-add": "\\ea79",
    "user-group-disable": "\\ea80",
    "user-groups-disable": "\\ea82",
    "user-lock": "\\ea83",
    "user-remove": "\\ea84",
    "user-search": "\\ea85",
    "user-unlock": "\\ea86",
    "video-card": "\\ea87",
    "view-detailed": "\\ea89",
    "web-camera": "\\ea92",
    "web-camera-hd": "\\ea93",
    "wifi-simple": "\\ea96",
    "windows-support": "\\ea97",
    "wrench-cir": "\\ea98",
    "wrench-double": "\\ea99",
    "package-closed": "\\ea0c",
    "package-open": "\\ea0d",
    "pie-chart": "\\ea1b",
    "pie-chart-solid": "\\ea1c",
    "power-supply-cord": "\\ea2b",
    "power-supply-double": "\\ea2c",
    processor: "\\ea2e",
    productivity: "\\ea2f",
    "removable-storage-usb": "\\ea3b",
    "server-rack-search": "\\ea4a",
    "server-rack-support": "\\ea4b",
    "shield-protect": "\\ea4f",
    "sort-za": "\\ea5d",
    "speaker-double": "\\ea5e",
    stack: "\\ea5f",
    toolbox: "\\ea6c",
    "touch-pad": "\\ea6d",
    translate: "\\ea6e",
    "user-cir-remove": "\\ea7a",
    "user-contact": "\\ea7b",
    "user-disable": "\\ea7d",
    "user-group-chat": "\\ea7f",
    "view-list": "\\ea8c",
    "view-row": "\\ea8d",
    "view-table": "\\ea8e",
    virtualization: "\\ea8f",
    "wrench-manage": "\\ea9a",
    "zoom-in": "\\ea9d",
    "zoom-out": "\\ea9e",
};

export const iconsUnicode = /* @__PURE__ */ Object.assign(
    {},
    defaultIconsUnicode,
    customIconsUnicode
);

// Inject meta.prefix
export default /* @__PURE__ */ Object.keys(iconsUnicode).reduce((acc, prop) => {
    acc[`${iconPrefix}${prop}`] = iconsUnicode[prop];
    return acc;
}, {});
